import { DATE_FORMAT, DateRageType } from '../../../../../types/common/date';
import moment from '../../../../../lib/moment';

export const getInitialPeriod = (period?: DateRageType) => {
  const initialStartDate =
    period?.startDate === null
      ? null
      : moment(period?.startDate || new Date().toISOString()).format(DATE_FORMAT.FULL_DASH_FORMAT);

  const initialEndDate =
    period?.endDate === null
      ? null
      : period?.endDate
        ? moment(period?.endDate).format(DATE_FORMAT.FULL_DASH_FORMAT)
        : moment(new Date().toISOString()).add(7, 'days').format(DATE_FORMAT.FULL_DASH_FORMAT);

  return {
    startDate: initialStartDate,
    endDate: initialEndDate,
  };
};
